import { useEffect, useState } from 'react';

// A picture the API serves (an advert's, a Gist photo), fetched with the session by `load` and shown from a
// file the page made (both apps only show pictures of their own: img-src 'self' blob:). `id` names the picture,
// so a new one loads when it changes.
export function BlobPicture({
  id,
  load,
  alt,
  className,
}: {
  id: string;
  load: () => Promise<Blob | null>;
  alt: string;
  className?: string;
}) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    let made: string | null = null;
    void load()
      .catch(() => null)
      .then((file) => {
        if (!live || !file) return;
        made = URL.createObjectURL(file);
        setUrl(made);
      });
    return () => {
      live = false;
      if (made) URL.revokeObjectURL(made);
    };
    // the picture is named by its id; `load` is made afresh on each render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return url ? (
    <img src={url} alt={alt} className={className} />
  ) : (
    <span className={`advert-picture-wait ${className ?? ''}`} aria-hidden="true" />
  );
}
